import { IAlbum } from "../../common/Album";

const album: IAlbum = {
  title: 'Church Sessions - Light of Church',
  date: new Date(2023, 4, 21),
  img: '/img/band.jpeg',
  tracks: [
    {
      title: 'Pacecar',
      src: '/songs/2023-05-21/pacecar.mp3',
    },
    {
      title: 'Redhanded',
      src: '/songs/2023-05-21/redhanded.mp3',
    },
    {
      title: 'Night & Dave',
      src: '/songs/2023-05-21/night_and_dave.mp3',
    },
    {
      title: 'Ferment Lament',
      src: '/songs/2023-05-21/ferment_lament.mp3',
    },
    {
      title: 'Harmoni Ca',
      src: '/songs/2023-05-21/harmoni_ca.mp3',
    },
    {
      title: 'Welcome Sunday Jam',
      src: '/songs/2023-05-21/welcome_sunday_jam.mp3',
    },
    {
      title: 'Polymer',
      src: '/songs/2023-05-21/polymer.mp3',
    },
    {
      title: 'American Cheese',
      src: '/songs/2023-05-21/american_cheese.mp3',
    },
    {
      title: 'Understated Elegance',
      src: '/songs/2023-05-21/understated_elegance.mp3',
    },
    {
      title: 'Nightshade',
      src: '/songs/2023-05-21/nightshade.mp3'
    },
    {
      title: 'Send-Off',
      src: '/songs/2023-05-21/send_off.mp3',
    },
  ]
}
export default album;